<template>
  <div class="content">
    <navigator title="支付"></navigator>
    <van-panel title="支付方式" desc="请选择支付方式" class="payment">
      <van-radio-group v-model="paymentId">
        <van-cell-group>
          <van-cell title="微信支付" @click="selectPaymentId(1)">
            <van-radio :name=1 />
          </van-cell>
          <van-cell title="月结" @click="selectPaymentId(2)" v-if="monthly">
            <van-radio :name=2 />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-panel>

    <van-panel title="" v-if="paymentId==1">
      <van-cell-group>
        <van-cell title="发票信息" is-link :value="invoiceText" @click="showInvoiceList = true" class="invoice-text"/>
      </van-cell-group>
    </van-panel>

    <div class="complaint">
      <router-link :to="`/propertyDetiles/${commonService.complaint}`">我要投诉</router-link>
    </div>

    <div class="footer">
      <div class="left">支付金额：<span>{{price / 100 | PriceFilter}}</span> 元</div>
      <div class="right" @click="onPay">支付</div>
    </div>

    <!-- 模态 -->
    <div class="modal" v-show='showInvoiceList'>
      <div class="close" @click="closeModal">
        <van-icon name="close" />
      </div>
      <div class="container">
        <van-radio-group v-model="invoiceId" @change="changeInvoiceId">
          <van-cell-group v-for="(item, index) in invoiceList" :key="item.invoiceId" class="invoice-list">
            <van-cell :title="item.invoiceType == 1 ? '普通发票' : '增值税发票'" @click="selectInvoiceId(item.invoiceType, item.invoiceTitle)">
              <van-radio :name="item.invoiceId" />
            </van-cell>
            <van-cell title="发票抬头" :value="item.invoiceTitle"></van-cell>
            <van-cell title="纳税人识别号" v-show="item.invoiceType == 2 || item.type==1" :value="item.creditCode"></van-cell>
            <van-cell title="注册地址" v-show="item.invoiceType == 2" :value="item.registerAddress"></van-cell>
            <van-cell title="注册电话" v-show="item.invoiceType == 2" :value="item.registerTel"></van-cell>
            <van-cell title="开户银行" v-show="item.invoiceType == 2" :value="item.bankName"></van-cell>
            <van-cell title="银行账号" v-show="item.invoiceType == 2" :value="item.bankAccount"></van-cell>
            <van-cell title="收票人手机" :value="item.receiverMobile"></van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-cell to="/personal/invoice">
          <p class="add" v-show="invoiceList.length<1">您还没有添加发票信息,去个人中心<span class="link"> 添加发票信息</span>。</p>
          <p class="add" v-show="invoiceList.length>=1" style="text-align: center"><span class="link"> 添加发票信息</span></p>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast } from 'vant';
import commonService from '@/static/commonService';

export default {
  data() {
    return {
      commonService: {},
      invoiceList: [],
      paymentType: 1,
      paymentId: 1,
      invoiceMarker: 1,
      invoiceText: '无需发票',
      pageIndex: 1,
      price: 0,
      invoiceId: 0,
      bindSN: 0,
      orderId: 0,
      monthly: false,
      showInvoiceList: false,
    }
  },
  created () {
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
    this.bindSN = this.$route.query.bindSN
    this.orderId = this.$route.query.orderId
    this.price = this.$route.query.price
    this.monthly = this.$route.query.monthly==1 ? true : false
    this.getList()
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList']),
  },
  methods: {
    getList(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/invoice/info/list`,{
        currPage: this.pageIndex,
        pageRows: 10,
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode == 10000){
          this.invoiceList = res.data.resData.pageList ? res.data.resData.pageList : [];
        }else{
          Toast(res.data.resDesc);
        }
      })
    },
    selectPaymentId(paymentId) {
      this.paymentId = paymentId==2 ? 2 : 1;
    },
    closeModal() {
      this.invoiceMarker = 1;
      this.invoiceId = 0;
      this.invoiceText = '无需发票';
      this.showInvoiceList = false;
    },
    selectInvoiceId(invoiceType, invoiceTitle) {
      let str = invoiceType == 1 ? '普通发票' : '增值税发票';
      this.invoiceMarker = 2;
      this.invoiceText = str + ' | ' + invoiceTitle;
    },
    changeInvoiceId(val) {
      this.showInvoiceList = false;
    },
    onPay(){
      if(this.paymentId==1){
        let strInvoice = this.invoiceMarker==2 ? `&invoiceId=${this.invoiceId}` : '';
        this.wxPay(strInvoice);
      }else if(this.paymentId==2){
        this.monthlyPay();
      }else{
        Toast.fail({ duration: 1500, message: '请选择支付方式' });
      }
    },
    wxPay(strInvoice=''){
      if(this.orderId){
        window.location.href = `${this.URL_PREFIX_PAGE}/smark/pay/wechat?orderId=${this.orderId}&paymentId=${this.paymentId}&wxTradeType=${2}&invoiceMarker=${this.invoiceMarker}${strInvoice}`;
      }else if(this.bindSN){
        window.location.href = `${this.URL_PREFIX_PAGE}/smark/pay/wechat?bindSN=${this.bindSN}&paymentId=${this.paymentId}&wxTradeType=${2}&invoiceMarker=${this.invoiceMarker}${strInvoice}`;
      }else{
        Toast.fail({ duration: 1500, message: '订单不存在' });
      }
    },
    monthlyPay(){
      let query = {
        paymentId: this.paymentId,
        wxTradeType: 2,
        orderId: this.orderId,
        invoiceMarker: 1,//月结无需发票
      }
      this.$http.post(`${this.URL_PREFIX}/app/pay/user/order/info`, {
        ...query
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          Toast.success({ duration: 1500, message: '支付成功' })
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          // 失败
          Toast.fail({ duration: 1500, message: res.resDesc });
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@scss';
.content{
  background: #efefef;
  .link{
    color: #0099FF;
  }
  .add{
    padding-top: 16px;
    font-size: 12px;
  }
  .payment{
    margin-top: 8px;
  }
  .info{
    margin-top: 8px;
  }
  .complaint{
    background: #fff;
    color: #0099FF;
    font-size: 14px;
    text-align: center;
    padding-top: 60px;
    padding-bottom: 60px;
    a{
      color: #0099FF;
    }
  }
  .footer{
    height: 56px;
    width: 100%;
    background-color: #f00;
    position: fixed;
    bottom: -10px;
    .left{
      height: 56px;
      background: rgb(51,51,51);
      width: 56%;
      float: left;
      z-index: 999;
      font-size: 15px;
      padding-top: 16px;
      padding-left: 9%;
      color: #fff;
      span{
        color: #fff;
        font-size: 16px;
      }
    }
    .right{
      height: 56px;
      background: #d9262c;
      color: #fff;
      padding-left: 10%;
      font-size: 20px;
      padding-top: 8px;
      width: 25%;
      float: right;
      z-index: 999;
    }
  }
}
.invoice-list{
  margin-bottom: 1rem;
}
.modal {
   @include modify_info;
}
.invoice-text{
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/Payment.vue